export const GTM_PLATFORM_VERSION = 4;
